import { render, staticRenderFns } from "./UpdateBirthday.vue?vue&type=template&id=fe899792&scoped=true&"
import script from "./UpdateBirthday.vue?vue&type=script&lang=js&"
export * from "./UpdateBirthday.vue?vue&type=script&lang=js&"
import style0 from "./UpdateBirthday.vue?vue&type=style&index=0&id=fe899792&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe899792",
  null
  
)

export default component.exports